import React from 'react';
import PropTypes from 'prop-types';

import { listItemPropTypes, reorderableListItem } from 'helpers/react_dnd/reorderable_list';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';

export class CompReportAttributeRow extends React.Component {
  static propTypes = {
    ...listItemPropTypes,
    option: PropTypes.object.isRequired,
    onRemoveAttribute: PropTypes.func
  }

  render() {
    const { option } = this.props;

    const style = {
      opacity: this.props.isDragging ? 0 : 1,
    };

    return this.props.connectDragPreview(this.props.connectDropTarget(this.props.connectDragSource(
      <li
        className="p-3 cursor-move"
        name="attributeRow"
        style={style}
      >
        <span className="right-buffer-md text-muted">
          <FontAwesomeIcon icon={faEllipsisV}/>
        </span>
        {option["label"]}
        <span className="pull-right">
          <FontAwesomeIcon
            className="text-danger clickable"
            icon={faTrashAlt}
            name="remove"
            onClick={() => this.props.onRemoveAttribute(option)}
          />
        </span>
      </li>
    )));
  }
}

export default reorderableListItem(CompReportAttributeRow, "CompReportAttributeSelector", {
  beginDrag(props) {
    return {
      index: props.index,
      option: props.option
    };
  }
});
